module.exports = __webpack_public_path__ + "media/img/apple-icon-76x76-2a035c7959d6185f563113796cb7555d.png";